/**
 * Safely retrieves and parses an object from localStorage
 * @param key - The localStorage key to retrieve
 * @returns The parsed object or null if not found or invalid JSON
 */
export const getLocalStorageObject = <T>(key: string): T | null => {
  const hasStorageValue = localStorage.getItem(key)
  return hasStorageValue ? (JSON.parse(hasStorageValue) as T) : null
}
